import { useFiltersStore } from "@app/dashboard/store/home/filters";
import { COUNTRIES } from "@app/dashboard/constants/countries";
import {
  formattedFilters,
  getDaysInRange,
  getValidTypesFromRange
} from "@app/dashboard/utils/charts";
import { getCountryFromDomain } from "@app/dashboard/utils/getCountryFromDomain";
import type { IHomeApisParams } from "@app/dashboard/types/innerLayout/home";
import TotalSales from "@app/dashboard/components/inner_layout/Charts/TotalSales";
import NetSales from "@app/dashboard/components/inner_layout/Charts/NetSales";
import TerminalsRevenue from "@app/dashboard/components/inner_layout/Charts/TerminalsRevenue";
import MethodsUsage from "@app/dashboard/components/inner_layout/Charts/MethodsUsage";
import FailureReasons from "@app/dashboard/components/inner_layout/Charts/FailureReasons";
import PerformanceHighlights from "@app/dashboard/components/inner_layout/Charts/PerformanceHighlights";
import styles from "./charts.module.scss";

  const { SAU, OMN } = COUNTRIES;
  const terminalsRevenueExcludedCountries = [SAU, OMN];

const Charts = () => {

  const { filters } = useFiltersStore();
  const { startDate, endDate } = filters;
  const daysInRange = getDaysInRange(startDate, endDate);
  const { rangeType, timeFormat } = getValidTypesFromRange(daysInRange);

  const params: IHomeApisParams = {
    ...formattedFilters(filters),
    res_type: rangeType
  };

  const country = getCountryFromDomain();
  
  return (
    <div className={styles["charts-wrapper"]}>
      <TotalSales
        apiParams={params}
        timeFormat={timeFormat}
        rangeType={rangeType}
      />
      <NetSales
        apiParams={params}
        timeFormat={timeFormat}
        rangeType={rangeType}
      />

      {
        !terminalsRevenueExcludedCountries.includes(country) && 
        <TerminalsRevenue
          apiParams={params}
          daysInRange={daysInRange}
        />
      }

      <MethodsUsage
        apiParams={params}
      />

      {/* <FailureReasons
        apiParams={params}
      /> */}
      <PerformanceHighlights
        apiParams={params}
      />
    </div>
  )
}

export default Charts;